/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx, Global } from '@emotion/react';
import React, { useState } from 'react';
import { EditProfileForm } from 'components/Form/EditProfileForm';

export const EditProfilePage = () => {
  return (
    <div>
      <EditProfileForm />
    </div>
  );
};
